import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default function useIntegrationList() {
    const toast = useToast()

    const refIntegrationListTable = ref(null)
    // Table Handlers
    const tableColumns = [
        { key: 'customerName', label: i18n.t('Customer'), sortable: false },
        { key: 'integrationName', label: i18n.t('Integration'), sortable: false },
        { key: 'expiresAtUtc', label: i18n.t('Expiration Date (UTC)'), sortable: true },
        { key: 'actions' },
    ]

    const perPage = ref(10)
    const totalIntegrations = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const customerId = ref('')
    const integration = ref(null)
    const expiredOnly = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refIntegrationListTable.value ? refIntegrationListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalIntegrations.value,
        }
    })

    const refetchData = () => {
        refIntegrationListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, customerId, integration, expiredOnly], () => {
        refetchData()
    })

    const fetchIntegrations = (ctx, callback) => {
        store
            .dispatch('app-integrations/searchIntegrations', {
                search: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                expiredOnly: expiredOnly.value,
                integration: integration.value,
                customerId: customerId.value,
            })
            .then(response => {
                const integrations = (response.data || []).map(item => ({
                    ...item,
                    rowId: `${item.customerId}-${item.integrationName}`,
                }))
                callback(integrations);
                totalIntegrations.value = response.totalItems;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: i18n.t('Error fetching integrations list'),
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }
    
    return {
        tableColumns,
        perPageOptions,
        fetchIntegrations,
        refIntegrationListTable,
        searchQuery,
        currentPage,
        perPage,
        customerId,
        integration,
        expiredOnly,
        refetchData,
        dataMeta,
        totalIntegrations,
    }
}